/* By Levane — estado "pegado" de la barra de cabecera.

   Pone la clase `is-stuck` en .bl-header__bar cuando la fila de marca (el
   sello apilado, centrado arriba del todo) ya ha pasado de largo. De ahi
   cuelga la aparicion del logo compacto; ver el {% stylesheet %} de
   sections/bl-header.liquid.

   Se usa un IntersectionObserver sobre un centinela de 1px en lugar de un
   listener de scroll: el callback solo corre al cruzar el umbral, no en cada
   frame. El tema Look ya arrastra tres listeners de scroll y no conviene
   sumar un cuarto.

   El centinela lo emite la propia seccion, entre la fila de marca y la barra.
   Si la seccion no lo trae (ajuste "logo completo arriba" desmarcado, o
   movil) no hay nada que observar y el script no hace nada: el logo compacto
   ya se ve por CSS. */
(function () {
  var io = null;

  function init() {
    if (io) { io.disconnect(); io = null; }

    var bar = document.querySelector('.bl-header__bar');
    var sentinel = document.querySelector('.bl-header-sentinel');
    if (!bar || !sentinel || !('IntersectionObserver' in window)) return;

    io = new IntersectionObserver(function (entries) {
      bar.classList.toggle('is-stuck', !entries[0].isIntersecting);
    }, { threshold: 0 });

    io.observe(sentinel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* En el editor de temas Shopify re-renderiza la seccion y el observer se
     quedaria apuntando a nodos que ya no existen. */
  document.addEventListener('shopify:section:load', function (e) {
    if (e.target && e.target.id === 'shopify-section-bl-header') init();
  });
  document.addEventListener('shopify:section:unload', function (e) {
    if (e.target && e.target.id === 'shopify-section-bl-header' && io) {
      io.disconnect();
      io = null;
    }
  });
})();
